import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccessTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .4,
		clipPath: "url(#clip0_867_26143)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7.99398 0.333374C4.31398 0.333374 1.33398 3.32004 1.33398 7.00004C1.33398 10.68 4.31398 13.6667 7.99398 13.6667C11.6807 13.6667 14.6673 10.68 14.6673 7.00004C14.6673 3.32004 11.6807 0.333374 7.99398 0.333374ZM8.00065 12.3334C5.05398 12.3334 2.66732 9.94671 2.66732 7.00004C2.66732 4.05337 5.05398 1.66671 8.00065 1.66671C10.9473 1.66671 13.334 4.05337 13.334 7.00004C13.334 9.94671 10.9473 12.3334 8.00065 12.3334Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.33398 3.66663H7.33398V7.66663L10.834 9.76663L11.334 8.94663L8.33398 7.16663V3.66663Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_867_26143",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgAccessTime;
